import React from 'react';
import { Card, Button, Row, Col } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import Dollars from '../../common/typeFormatting/Dollars';

const VoucherGroupInfo = ({ voucherGroup }) => {
  const history = useHistory();

  const handleEdit = () => {
    history.push(`/travel/vouchergroups/${voucherGroup.voucherGroupId}/edit`);
  };

  const expirationText = voucherGroup.defaultExpiresAfterInYears 
    ? `${voucherGroup.defaultExpiresAfterInYears} years`
    : 'Does not expire';

  return (
    <Card className="mb-4">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <Card.Title>{voucherGroup.groupName}</Card.Title>
          <Button variant="primary" onClick={handleEdit}>Edit Group Settings</Button>
        </div>
        <Row>
          <Col md={6} className="text-center">
            <div className="text-muted mb-1">Default Amount</div>
            <div><Dollars>{voucherGroup.defaultInitialAmount}</Dollars></div>
          </Col>
          <Col md={6} className="text-center">
            <div className="text-muted mb-1">Default Expiration</div>
            <div>{expirationText}</div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default VoucherGroupInfo;